import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import keycloak from '../auth/keycloak'

interface AuthGuardProps {
  children: React.ReactNode
  requiredRole?: string
}

export default function AuthGuard({ children, requiredRole }: AuthGuardProps) {
  const { authenticated, initializing, hasRole } = useAuth()

  if (!authenticated) {
    if (initializing) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" />
            <p className="text-slate-600">Загрузка...</p>
          </div>
        </div>
      )
    }
    keycloak.login()
    return null
  }

  // Access is by role possession, not the active cabinet — a multi-role user may open any
  // cabinet they hold. The active cabinet only governs default landing and navigation.
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
